import Vue from 'vue'
import Vuex from 'vuex'
import BourseStore from './DemandeBourse/BourseStore'
import CatalogueStore from './CatalogueStore'
import RulesStore from './RulesStore'
import ConcoursStore from './ConcoursExtranet/ConcoursStore'
import StoreDossierBourse from './DossierBourse/DossierBourseStore'
import StoreBourseUm6p from './CandidatureBourseFirsi/Um6pStore'
import StoreInscriptionUni from './InscriptionUniversite/InscripionUniversiteStore'
import StoreAnnexesInscrUm6p from './InscriptionUniversite/AnnexesUm6pStore'
import StoreCommun from './Commun/CommunStore'
import StoreBourse from './BourseEcoleCentrale/BourseStore'
import StoreSousMenu from './SousMenuUm6p/SousMenuUm6pStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
  BourseStore, 
  CatalogueStore, 
  RulesStore,
  ConcoursStore,
  StoreDossierBourse,
  StoreBourseUm6p,
  StoreInscriptionUni,
  StoreAnnexesInscrUm6p,
  StoreCommun,
  StoreSousMenu,
  StoreBourse
})
